module.exports = __webpack_public_path__ + "img/img_aboutus_joinus.1c900aaa.jpg";